import cohortTabTemplate from './cohortTabTemplate';

export default cohortTabTemplate(['cohort'], ({ cohorts }) => cohorts.create);
